import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { WorkPageWrapper } from '../ManagementAssetWarehouseStylePage'
import DashboardLayout from '../../../layouts/DashboardLayout'
import { Helmet } from 'react-helmet'
import PageTitle from '../../../components/PageTitle'
import AccessControlAction from '../../../components/AccessControlAction'
import { Button, DatePicker, Menu } from 'antd'
import { FileExcelOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import moment from 'moment'
import { exportAssetStatisticsExcel } from './ExportAssetStatisticExcel'
import ExportDistributeVoteTable from './ExportDistributeVoteTable'
import { exportDistributeVoteExcel } from './ExportDistributeVoteExcel'

const ExportDistributeVotePage = props => {
    const { managementAssetWarehouseStore } = props
  const [currentDate, setCurrentDate] = useState(
    moment(new Date()).format('MM-YYYY')
  )
  const [isLoading, setIsLoading] = useState(false)
  const { pageIndex, sizeIndex } = managementAssetWarehouseStore

  useEffect(() => {
    ;(async () => {
      await managementAssetWarehouseStore.clearFilter()
    })()
  }, [])

  const onChange = (date, dateString) => {
    setCurrentDate(dateString)
  }

  //Xuất excel
  const exportAssetStatisticExcel = async () => {
    try {
      const result = await managementAssetWarehouseStore.getExportDistributeVoteStatisticsExcel({
        monthYear: currentDate,
      })
      await exportDistributeVoteExcel(
        result.data, currentDate
      )
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    ;(async () => {
      await loadManagerInventoryList()
    })()
  }, [pageIndex, sizeIndex, currentDate])

  //Lấy dữ liệu từ store
  const loadManagerInventoryList = async () => {
    try {
      setIsLoading(true)
      const result  = await managementAssetWarehouseStore.getExportDistributeVoteStatistics({
        monthYear: currentDate,
      })
      return result
    } catch (e) {
      console.log(e)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <WorkPageWrapper>
      <DashboardLayout>
        <Helmet>
          <title>Hành chính | Quản lý kho | Báo cáo sử dụng văn phòng phẩm</title>
        </Helmet>

        <PageTitle location={props.location}>
          <AccessControlAction check={true}>
            <div>
              <DatePicker
                onChange={onChange}
                picker="month"
                format="MM-YYYY"
                defaultValue={moment()}
                style={{ marginRight: '5px' }}
              />

              <Button
                style={{ marginRight: '10px' }}
                icon={<FileExcelOutlined />}
                onClick={() => exportAssetStatisticExcel()}>
                Xuất excel (.xlsx)
              </Button>
            </div>
          </AccessControlAction>
        </PageTitle>
        <ContentBlockWrapper>
          <Menu
            mode="horizontal"
            selectedKeys={[props.location?.pathname]}
            style={{ marginBottom: 16 }}>
            <Menu.Item key="/manager-inventory/inventory-asset">
              <Link to={'/manager-inventory/inventory-asset'}>Tài sản</Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/manage-inventory-asset">
              <Link to={'/manager-inventory/manage-inventory-asset'}>
                Loại văn phòng phẩm
              </Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/statistic">
              <Link to={'/manager-inventory/statistic'}>
                Thống kê tài sản tháng {currentDate}
              </Link>
            </Menu.Item>

            <Menu.Item key="/manager-inventory/export-statistic">
              <Link to={'/manager-inventory/export-statistic'}>
                Báo cáo sử dụng văn phòng phẩm theo tháng {currentDate}
              </Link>
            </Menu.Item>
          </Menu>

          <ExportDistributeVoteTable
            isLoading={isLoading}
            currentDate={currentDate}
          />
        </ContentBlockWrapper>
      </DashboardLayout>
    </WorkPageWrapper>
  )
}
export default inject('managementAssetWarehouseStore')(
    observer(ExportDistributeVotePage)
  )